import { gql } from '@apollo/client'

export const createMoveOutQuery = gql`
  mutation CreateMoveOut($moveOutInput: MoveOutInputType!) {
    createMoveOut(moveOutInput: $moveOutInput) {
      move_out_id
      move_out_reason_id
      ntv_date
      forwarding_address_id
      move_out_date
    }
  }
`
